import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

/**
 * Botão de voltar padrão do sistema — mesmo chevron usado nas telas de operação
 * (aquisição). Fica ao lado do título. Ícone-only, preto.
 */
const BotaoVoltar: React.FC<{ onClick: () => void; title?: string; className?: string }> = ({
  onClick,
  title = 'Voltar',
  className,
}) => (
  <button
    type="button"
    className={className}
    onClick={onClick}
    title={title}
    aria-label={title}
    style={{
      background: 'none',
      border: 'none',
      padding: 0,
      marginRight: 8,
      cursor: 'pointer',
      color: '#000',
      fontSize: '1.2rem',
      lineHeight: 0,
      display: 'inline-flex',
      alignItems: 'center',
    }}
  >
    <FontAwesomeIcon icon={faChevronLeft} color="black" />
  </button>
);

export default BotaoVoltar;
